"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChildSurveyResponses = getChildSurveyResponses;
const taskStore_1 = require("../../../taskStore");
function getChildSurveyResponses() {
    const t = (0, taskStore_1.taskStore)().translations;
    const responses = t.childSurveyRespoonses || t.childSurveyResponses;
    return responses.split(';');
}
